var Provider = require('./Provider');

module.exports = Provider.extend({
    indexUrl: '/app/help/assistant/gethelpindex/',

    initialize: function() {
        this.indexUrl += '?cacheKey=' + jimdoData.search.helpCacheKey;
    },

    buildResults: function(results) {
        var helpResultsFinal = [];

        results = this._super(results);

        /**
         * XXX: This filtering of results by features is a hack! See DHDIYTB-489.
         * Also see stdjs.php, which defines jimdoData.helpFeatures.
         */
        var featureList, anyFeatureActive;
        for (var rIndex = 0; rIndex < results.length; rIndex++) {
            featureList = results[rIndex]['featureList'];
            if (featureList && featureList.length && jimdoData.helpFeatures) {
                anyFeatureActive = false;
                for (var listIndex = 0; listIndex < featureList.length; listIndex++) {
                    if (1 === jimdoData.helpFeatures[featureList[listIndex]]) {
                        anyFeatureActive = true;
                        break;
                    }
                }
                if (!anyFeatureActive) {
                    // remove result because it had feature dependencies
                    // and we didn't find at least one active
                    delete results[rIndex];
                }
            }
        }

        /* first add the featured=true to the top */
        for (var j = 0; j < results.length; j++) {
            // XXX: remember to test that results[j] is not undefined; may have been removed by delete above
            if (results[j] && results[j].featured) {
                helpResultsFinal.push(results[j]);
            }
        }

        /* and the featured=false to the bottom */
        for (var k = 0; k < results.length; k++) {
            // XXX: remember to test that results[k] is not undefined; may have been removed by delete above
            if (results[k] && !results[k].featured) {
                helpResultsFinal.push(results[k]);
            }
        }

        return helpResultsFinal;
    },

    /**
     * perform the action for the given search result
     * in this case, open help window to that topic
     * @param ref help topic
     * @param ev event that got to this action
     */
    action: function(ref) {
        //Hack: remove this when search elements feature is permanently ON
        //The new search gives the result hash as a parameter instead of the slug itself
        if (ref.slug) {
            ref = ref.slug;
        }

        /* simulating opening of the help window */
        var $el = jQuery('<div data="' + ref + '"></div>'),
            e = {currentTarget: $el[0]};

        guidedAssistant._onModuleHelpLinkClick.call(guidedAssistant, e);
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/search/providers/Help.js
 ** module id = 851
 ** module chunks = 0
 **/